import React, {createContext, useReducer} from "react"
import {CORE_AMZL, DEFAULT_REFRESH_INTERVAL} from "../../util/Constants";
import {CapabilityReducer} from "../reducers/CapabilityReducer";
import {isDevelopmentEnv} from "../../util/Util";

// used while in development mode mostly in local machine
let devCapabilityModel = {
    capability: CORE_AMZL,
    // baseUrl: 'https://logistics-co-uk-preprod.amazon.com',
    // baseUrl: 'https://logistics-jp-preprod-pdx.pdx.proxy.amazon.com',
    baseUrl: 'https://logistics-preprod.amazon.com',
    // baseUrl: 'https://logistics.amazon.com',
    stationConfig: {
        initialised: true,
        pickStageDecoupleEnabled: false,
        splitStagingEnabled: false,
        parallelPickEnabled: false,
        authEnabled: false,
        multiStationPicklistViewEnabled: true,
        missingStagingLocationAlertThreshold: undefined,
        refreshInterval: DEFAULT_REFRESH_INTERVAL,
        dropToCartEnabled: false,
        disableForceAssignForUnSplittedRoutes: false,
        routeDetailsTabViewEnabled: false,
        unassignPickerEnabled: false
    }
}

export const CapabilityContext = createContext()

const initialState = isDevelopmentEnv() ? devCapabilityModel : {
    capability: '',
    baseUrl: '',
    stationConfig: {
        initialised: false,
        pickStageDecoupleEnabled: false,
        splitStagingEnabled: false,
        parallelPickEnabled: false,
        authEnabled: false,
        layoutGridViewEnabled: false,
        multiStationPicklistViewEnabled: false,
        missingStagingLocationAlertThreshold: undefined,
        refreshInterval: DEFAULT_REFRESH_INTERVAL,
        dropToCartEnabled: false,
        disableForceAssignForUnSplittedRoutes: false,
        routeDetailsTabViewEnabled: false,
        unassignPickerEnabled: false
    }
}

const CapabilityContextProvider = (props) => {
    const [ configViewModel, configDispatch ] = useReducer(CapabilityReducer, initialState)
    return (
        <CapabilityContext.Provider value = {{configViewModel, configDispatch}}>
            {props.children}
        </CapabilityContext.Provider>
    )
}

export default CapabilityContextProvider


// WEBPACK FOOTER //
// ./src/components/global/context/CapabilityContext.js